import { render, staticRenderFns } from "./soleBackTop.vue?vue&type=template&id=6453a230&"
import script from "./soleBackTop.vue?vue&type=script&lang=js&"
export * from "./soleBackTop.vue?vue&type=script&lang=js&"
import style0 from "./soleBackTop.vue?vue&type=style&index=0&id=6453a230&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports